// extracted by mini-css-extract-plugin
module.exports = {"section":"_1VrKI","list":"_2rD3B","listItem":"_3R8AP","firstTier":"_3ww6E","secondTier":"_1S2gO","listItemImg":"_2d67w"};